import React, { useEffect, useRef } from 'react';
import withStyles from 'react-jss';
import { Trans, useTranslation } from 'react-i18next';
import PlusIcon from '../utility/PlusIcon';

const ecapModalStyling = {
  horizontalLineColor: (props) => ({
    border: `3px solid ${props.tenant.secondary}`,
  }),
};

function ECAPModal(props) {
  const { t } = useTranslation();

  const classButton = {
    backgroundColor: props.tenant.primary,
    width: '15px',
    height: '15px',
    padding: '3px',
    display: 'inline-flex',
    verticalAlign: 'middle',
    textAlign: 'center',
  };

  const { showModal, handleCloseModal, isMobile, notAllowedModal } = props;
  const wrapperRef = useRef(null);

  const useOutsideAlerter = (ref) => {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          if (showModal) handleCloseModal();
        }
      }

      function handleKeyPressOutside(e) {
        if (['Enter'].includes(e.key)) handleClickOutside(e);
      }

      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleKeyPressOutside);

      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleKeyPressOutside);
      };
    }, [ref]);
  };

  /* eslint-disable react/jsx-one-expression-per-line */
  const displayModalTopContent = () => {
    return isMobile ? (
      <div className="modal-content modal-content-top" ref={wrapperRef}>
        <p>
          <Trans>
            Click the <em>Plus Icon</em>{' '}
            <span className="class-button" style={classButton}>
              <PlusIcon width="10" height="10" />
            </span>{' '}
            to add classes from the class list to your yearly plan. You can add
            up to two classes per field.
          </Trans>
        </p>
      </div>
    ) : (
      <div className="modal-content modal-content-top" ref={wrapperRef}>
        <p>
          <Trans>
            Click <em>Expand Year</em>, then drag and drop your classes from the
            class list on the right into your yearly plan. You can add up to two
            classes per field.
          </Trans>
        </p>
      </div>
    );
  };

  useOutsideAlerter(wrapperRef);

  const displayNotAllowedModal = () => {
    return (
      <p>
        {t(
          "The course tracking feature is only available for bachelor’s degrees. Use the 'Switch Career Choice' arrows to navigate to your next pairing to see if ECAP functionality applies."
        )}
      </p>
    );
  };

  const displayDefaultModal = () => {
    return (
      <>
        {displayModalTopContent()}
        <hr
          className={[
            'modal-horizontal-line',
            props.classes.horizontalLineColor,
          ].join(' ')}
        />
        <div className="modal-content modal-content-bottom" ref={wrapperRef}>
          <p>
            <Trans>
              If you don’t see an offered course, you can add a new one using
              the <em>Custom Class</em> option.
            </Trans>
          </p>
        </div>
      </>
    );
  };

  return (
    <div
      className={
        notAllowedModal ? 'ecap-modal not-allowed' : 'ecap-modal default'
      }
    >
      {notAllowedModal ? displayNotAllowedModal() : displayDefaultModal()}
    </div>
  );
}

export default withStyles(ecapModalStyling)(ECAPModal);
